import script from "./FileUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./FileUploader.vue?vue&type=script&setup=true&lang=js"

import "./FileUploader.vue?vue&type=style&index=0&id=14f33f11&lang=scss&scoped=true"

import exportComponent from "/soma-ui-vue-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14f33f11"]])

export default __exports__